export class ProgramPublicProfileInformation {
    public name: string;
    public description: string;
    public address: string;
    public phoneNumber: string;
    public website: string;
    public agency: string;
    public setting: string;
    public numberServed: number;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program-public-profile-information.ts